module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAk0lEQVRIic2WUQoAIQhEZQ8bdLmu1+fsT0HEttukDCsEQeYTtdQAFAAVQAJgwSs128XapksOhOTBbu3UUSJgebKZVgce2KOtT4UIyAzywl7v0hdOICsQC9vSdXnJOOQJCRXi0yTTeTytKArCgFaw7fK/TCV/Cp2kGCTlLXmwki9I8qlK2oSk8UlauWw4kY1bkgHyBoG/R/eWKUp7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/images/icon_close_02.png
// module id = 181
// module chunks = 1